<template>
  <div class="animated fadeIn">
    <b-form @submit.prevent="onSubmit">
      <b-card no-body>
        <b-card-header>
          <span class="text-muted text-uppercase">{{ form_label ? form_label : customer_grower ? `Update ${customer_grower.name}` : "New Grower" }}</span>
        </b-card-header>

        <div class="py-3 px-5">
          <b-form-group label="Name" :label-cols="3">
            <b-form-input
              v-model="form_data.name"
              :state="!$v.form_data.name.$invalid"
              invalid-feedback="Required"
              placeholder="Name"
              type="text"
            />
          </b-form-group>
        </div>
      </b-card>

      <b-row>
        <b-col>
          <b-button @click="onSubmit" class="my-4 float-right py-3 px-5" variant="success">
            <i class="fal fa-save" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: "CustomerGrowerForm",
  mixins: [validationMixin],
  props: {
    customer_grower: {
      type: Object,
      default: null
    },
    form_label: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      form_data: {
        name: null
      }
    }
  },
  validations: {
    form_data: {
      name: { required },
    }
  },
  created () {
    if (this.customer_grower) {
      this.form_data = {
        name: this.customer_grower.name
      }
    }
  },
  methods: {
    onSubmit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('submit', this.form_data)
      }
    }
  }
}
</script>
